import {
  FIND_ASSIGNABLE_PRODUCT_FILES,
  SortDirectionEnum,
} from '@gripp/shared-logic';
import { AssignmentListGrid } from '@gripp/shared-ui';
import { ColumnDef } from '@tanstack/react-table';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useFileColumns } from './useFileColumns';

export type ProductFilesAssignListProps = {
  workspaceId: string;
  productId: string;
  maxHeight?: number;
  keyword?: string;
  assignments: string[];
  updateAssignments: (assignments: string[]) => void;
};

export const ProductFilesAssignList = ({
  workspaceId,
  productId,
  maxHeight,
  keyword,
  assignments,
  updateAssignments,
}: ProductFilesAssignListProps) => {
  const { t } = useTranslation();
  const [filter, setFilter] = useState<any>(() =>
    workspaceId
      ? { keyword, productId, assignments: assignments || [], workspaceId }
      : undefined
  );

  const columns = useFileColumns() as ColumnDef<any, any>[];

  useEffect(() => {
    if (!workspaceId) return;
    setFilter({ keyword, productId, assignments, workspaceId });
  }, [keyword, productId, workspaceId]);

  if (!filter) return null;

  return (
    <AssignmentListGrid
      modelName="file"
      query={FIND_ASSIGNABLE_PRODUCT_FILES}
      dataPrefix="product.findAssignableFilesForProduct"
      columns={columns}
      filter={filter}
      assignments={assignments}
      onAssignmentsChange={updateAssignments}
      maxHeight={maxHeight}
      textEmpty={t('files.textEmpty')}
      orderBy={{ field: 'name', order: SortDirectionEnum.Asc }}
    />
  );
};
